import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { ProjectHolder } from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';

@Component({
  selector: 'app-install-pmnt-status-edit',
  templateUrl: './install-pmnt-status-edit.component.html',
  styleUrls: ['./install-pmnt-status-edit.component.scss']
})
export class InstallPmntStatusEditComponent implements OnInit {
  project: Project;

  @Input()
  status: ProjectStatus;
  tempStatus: ProjectStatus;

  statuses: ProjectStatus[];

  constructor(
    protected projectHolder: ProjectHolder,
    private projectService: ProjectService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.projectService.getInstallationPaymentStatuses().subscribe(statuses => {
      this.statuses = statuses
      if(this.status) {
        this.tempStatus = this.status;
      }
    });
  }

  statusChange(status: ProjectStatus) {
    this.status = status
    this.projectService
    .saveProject({
      id: this.project.id,
      installationPaymentStatus: this.status
    })
    .subscribe(() => {
      this.tempStatus = this.status
    }, error => {
      this.status = this.tempStatus
    })
  }

}
